import { createBrowserRouter, RouterProvider } from "react-router-dom";
import styled from "styled-components";

import IntroPage from "./components/Intro";
import GamePage from "./components/Game";
import ResultPage from "./components/Result";
import AppLayout from "./components/shared/AppLayout";

const StyledApp = styled.div`
  font-family: Pretendard;
  width: 360px;
  height: 800px;
  overflow-y: scroll;
  background-color: ${(props) => props.theme.color.white};

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AppLayout>
        <IntroPage />
      </AppLayout>
    ),
  },
  {
    path: "/game",
    element: (
      <AppLayout>
        <GamePage />
      </AppLayout>
    ),
  },
  {
    path: "/result/:garbageQtty",
    element: (
      <AppLayout>
        <ResultPage />
      </AppLayout>
    ),
  },
]);

const App = () => {
  return (
    <StyledApp>
      <RouterProvider router={router} />
    </StyledApp>
  );
};

export default App;
